module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_315deg.caa1f0b8.png";